export default __webpack_public_path__ + "static/media/hc-5.e71959d3.mp4";